import axios from 'axios';

// ==========================================
// 1. CONFIGURACIÓN ROBUSTA
// ==========================================
const api = axios.create({
  // Asegúrate de que esta URL sea correcta y no tenga espacios al final
  baseURL: 'https://floreria-back.onrender.com/api', 
  
  // Aumentamos el tiempo de espera a 30s porque Render (gratis) tarda en "despertar"
  timeout: 30000, 
  
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// ==========================================
// 2. INTERCEPTOR DE SOLICITUD (Token)
// ==========================================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("❌ Error en la solicitud:", error);
    return Promise.reject(error);
  }
);

// ==========================================
// 3. INTERCEPTOR DE RESPUESTA (Errores)
// ==========================================
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // A. Error de Red / Servidor Caído
    if (!error.response) {
      console.error("🚨 Error de Red o Servidor no responde (Render dormido):", error.message);
      // Opcional: Podrías retornar un error personalizado para mostrar en la UI
      return Promise.reject(new Error("No se pudo conectar con el servidor. Puede que se esté iniciando..."));
    }

    const { status, data } = error.response;

    // B. Logs de Depuración (Para que veas qué pasa en consola)
    console.error(`❌ API Error [${status}]:`, data);

    // C. Manejo de Verificación (Caso Especial)
    // Permite que el Login maneje esto para mostrar el modal de OTP
    if (status === 403 && data.requireVerification) {
      return Promise.reject(error);
    }

    // D. Sesión Expirada o Inválida (401 / 403)
    // Evita bucles infinitos: No redirigir si ya estás en login o registro
    if (status === 401 || (status === 403 && !data.requireVerification)) {
      console.warn("🔒 Sesión caducada o inválida. Cerrando sesión...");
      
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register' && currentPath !== '/') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;